import { Button, cn } from '@riac/design-system';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LoginContext } from 'src/lib/LoginContext';
import styled from 'styled-components';

export const LoginToUseContainer = styled.div`
  position: relative;
  min-height: 64px;
`;

const OverlayBaseStyle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;

  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  justify-content: center;

  opacity: ${(props) => props.$alwaysShow ? 1 : 0};
  background: rgba(0, 0, 0, 0.6);
  color: rgba(255, 255, 255, 0.85);
  text-align: center;

  & > ${Button} {
    flex: 1 1 100%;
    justify-content: center;
  }
`;

export const LoginToUseOverlay = styled(OverlayBaseStyle)`
  ${({ theme }) => `@media screen and (max-width: ${theme.screenWidths.desktop - 1}px)`} {
    display: none   
  }

  &:hover {
    opacity: 1;
  }
`;

export const LoginToUseOverlayMobile = styled(OverlayBaseStyle)`
  ${({ theme }) => theme.desktop} {
    display: none;
  }
`;

export type LoginToUseProps = React.PropsWithChildren<{
  overlayText: string,
  hideChildren?: boolean,
  alwaysShowOverlay?: boolean,
  childrenWrapperClassName?: string,
}>;

export const LoginToUse = (props: LoginToUseProps): JSX.Element => {
  const [mobilePressedState, setMobilePressedState] = useState<boolean>(props.alwaysShowOverlay);
  const mobileOverlayRef = useRef<HTMLDivElement>();
  const { isLoggedIn } = useContext(LoginContext);
  const location = useLocation();

  useEffect(() => {
    if(mobileOverlayRef.current) {
      mobileOverlayRef.current.style.opacity = mobilePressedState ? '1' : '0';
    }
  }, [mobilePressedState]);
  return (
    <LoginToUseContainer>
      {!isLoggedIn && (
        <>
          <LoginToUseOverlay $alwaysShow={props.alwaysShowOverlay}>
            <Button
              to = {`/login?referrer=${location.pathname}${location.search}${location.hash}`}
            >
              {props.overlayText}
            </Button>
          </LoginToUseOverlay>
          <LoginToUseOverlayMobile
            onClick={() => {
              if(!mobilePressedState) {
                setMobilePressedState(true);
              }
            }}
            ref = {mobileOverlayRef}
          >
            {mobilePressedState && (
              <Button
                to = {`/login?referrer=${location.pathname}${location.search}${location.hash}`}
                onBlur={() => {
                  setMobilePressedState(false);
                }}
                forceFocus={mobilePressedState && !props.alwaysShowOverlay}
              >
                {props.overlayText}
              </Button>
            )}
          </LoginToUseOverlayMobile>
        </>
      )}
      <div className={cn(props.hideChildren && !isLoggedIn ? 'invisible' : '', props.childrenWrapperClassName)}>
        {props.children}
      </div>
    </LoginToUseContainer>
  );
};
